module.exports = __webpack_public_path__ + "assets/media/warning.6cea4496.svg";